<template>
    <div v-if='media && media.media_type == "Audio"' v-show='media.media_type == "Audio"'>
        <audio :src='media.full_path' controls autoplay>
            Sorry, your browser does not support embedded audio.
            However, you may download this audio file <a :href='media.full_path'>here</a>.
        </audio>
    </div>
</template>

<script>
    import EventHub from './eventHub.js'

    export default {
        props: ['media'],
    }
</script>

<style scoped>
    div {
        height: 100%;
        text-align: center;
        padding-top: 75px;
    }
</style>
